import type { FC } from 'react';
import PropTypes from 'prop-types';
import { Button, Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import type { SxProps } from '@material-ui/system';
import PeopleIcon from '@material-ui/icons/People';
import { Plus as PlusIcon } from '../../icons/plus';

interface ResourceUnavailableProps {
  onCreate?: () => void;
  sx?: SxProps;
}

const ResourceUnavailableRoot = styled('div')(
  ({ theme }) => ({
    alignItems: 'center',
    backgroundColor: theme.palette.neutral[100],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(3),
    borderRadius: '6px',
  })
);

export const NoAccountFound: FC<ResourceUnavailableProps> = (props) => {
  const { onCreate, ...other } = props;

  return (
    <ResourceUnavailableRoot {...other}>
      <PeopleIcon
        sx={{ color: 'text.secondary' }}
        fontSize="large"
      />
      <Typography
        color="textSecondary"
        variant="body2"
      >
        No Account Found.
      </Typography>
      {onCreate && (
        <Button
          color="primary"
          onClick={onCreate}
          startIcon={<PlusIcon fontSize="small" />}
          sx={{ mt: 2 }}
          variant="contained"
        >
          Create Account
        </Button>
      )}
    </ResourceUnavailableRoot>
  );
};

NoAccountFound.propTypes = {
  onCreate: PropTypes.func
};
